import { useState } from 'react';
import { Button, Toolbar } from 'react95';
import { TAB_IDS } from '../constants';
import { useLocale } from '../i18n/LocaleContext';
import SettingsMenu from './SettingsMenu';

const Tabs = ({ activeTab, onChange }) => {
  const { t } = useLocale();
  const [settingsOpen, setSettingsOpen] = useState(false);
  const tabs = TAB_IDS.map((id) => ({ id, label: t.tabs[id] }));

  const selectTab = (tabId) => {
    setSettingsOpen(false);
    onChange(tabId);
  };

  const moveFocus = (nextIndex) => {
    selectTab(tabs[nextIndex].id);
  };

  return (
    <Toolbar className="tabs-toolbar" role="tablist" aria-label={t.tabsLabel}>
      {tabs.map((tab) => {
        const isSelected = activeTab === tab.id;
        const isPressed = isSelected && !settingsOpen;
        const insertSettingsBefore = tab.id === 'aboutApp';

        return (
          <span key={tab.id} className="tabs-item-group">
            {insertSettingsBefore && (
              <SettingsMenu open={settingsOpen} onOpenChange={setSettingsOpen} />
            )}
            <Button
              variant="menu"
              role="tab"
              id={`tab-${tab.id}`}
              aria-selected={isSelected}
              aria-controls={`panel-${tab.id}`}
              tabIndex={isSelected ? 0 : -1}
              active={isPressed}
              onClick={() => selectTab(tab.id)}
              onKeyDown={(event) => {
                const currentIndex = tabs.findIndex((item) => item.id === activeTab);
                let nextIndex = currentIndex;

                if (event.key === 'ArrowRight') {
                  nextIndex = (currentIndex + 1) % tabs.length;
                } else if (event.key === 'ArrowLeft') {
                  nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
                } else if (event.key === 'Home') {
                  nextIndex = 0;
                } else if (event.key === 'End') {
                  nextIndex = tabs.length - 1;
                } else {
                  return;
                }

                event.preventDefault();
                moveFocus(nextIndex);

                requestAnimationFrame(() => {
                  document.getElementById(`tab-${tabs[nextIndex].id}`)?.focus();
                });
              }}
            >
              {tab.label}
            </Button>
          </span>
        );
      })}
    </Toolbar>
  );
};

export default Tabs;
